/**
 * TechnologyCapability CRUD
 */

import type { TechnologyCapability } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateTechnologyCapabilityInput {
  name: string;
  description?: string;
  domainId?: string;
  tags?: string[];
  notes?: string;
}

export interface UpdateTechnologyCapabilityInput {
  name?: string;
  description?: string;
  domainId?: string;
  tags?: string[];
  notes?: string;
}

const client = createEntityCrudClient<
  TechnologyCapability,
  CreateTechnologyCapabilityInput,
  UpdateTechnologyCapabilityInput
>('/technology-capabilities');

/**
 * Create a new technology capability
 */
export async function createTechnologyCapability(
  input: CreateTechnologyCapabilityInput
): Promise<TechnologyCapability> {
  return client.create(input);
}

/**
 * Update an existing technology capability
 */
export async function updateTechnologyCapability(
  technologyCapabilityId: string,
  input: UpdateTechnologyCapabilityInput
): Promise<TechnologyCapability> {
  return client.update(technologyCapabilityId, input);
}

/**
 * Delete a technology capability
 */
export async function deleteTechnologyCapability(
  technologyCapabilityId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(technologyCapabilityId, hardDelete);
}
